<form [formRoot]="form()">
  <div class="flex flex-col mt-4 gap-6">
    <!-- Project / Task / Location -->
    <proffeo-project-task-selector
      (companyChange)="onCompanyChange()"
      [selection]="form().projectTask"
      [readonly]="isReadonlyMode()"
      [preselection]="projectTaskPreselection()"
    >
      <!-- User - same searchable select pattern as the reports list filters -->
      @if (allowSelectUser()) {
        <proffeo-ui-select
          (valueChange)="onUserIdSelected($event)"
          [formField]="form().userId"
          [options]="companyUserOptions()"
          [searchable]="true"
          [translateLabels]="false"
          beside-company
          errorMessage="ui-forms-this-field-is-required"
          label="time-reports.absence-dialog.user"
        />
      } @else if (selectedUserDisplayName()) {
        <proffeo-ui-input
          [formField]="form().userName"
          beside-company
          prefixIcon="person"
          label="time-reports.absence-dialog.user"
        />
      }

      @if (!seriesActive()) {
        <proffeo-ui-date-picker
          [formField]="form().date"
          between-company-and-project
          label="time-report-date"
        />
      }
    </proffeo-project-task-selector>

    <div class="proffeo-ui-surface-card flex flex-col gap-3 p-3">
      <!-- Manual / Range switch, owned by the hosting dialog -->
      <ng-content select="[mode-switch]" />

      @if (showManualHoursBreakdown()) {
        <proffeo-manual-hours-duration-fields
          [durations]="form().manualDurations"
          [minuteStep]="currentMinuteStep()"
        ></proffeo-manual-hours-duration-fields>

        @if (manualDurationsShowError()) {
          <mat-error class="text-sm">
            {{ 'ui-forms-time-duration-is-required' | translate }}
          </mat-error>
        }
      } @else {
        <proffeo-time-input-section
          (quickTimeSelected)="onQuickTimeSelected($event)"
          [mode]="selectedValue()"
          [manualTime]="form().manualTime"
          [timeRange]="form().timeRange"
          [minuteStep]="currentMinuteStep()"
        >
          <proffeo-ui-select
            [formField]="form().hourType"
            [options]="hourTypes()"
            after-time-fields
            errorMessage="ui-forms-this-field-is-required"
            label="time-report-hour-type"
          />
        </proffeo-time-input-section>
      }

      @if (showManualHoursBreakdown()) {
        <proffeo-ui-select
          (valueChange)="onBreakdownHourTypeChange($event)"
          [formField]="form().hourType"
          [options]="hourTypes()"
          errorMessage="ui-forms-this-field-is-required"
          label="time-report-hour-type"
        />
      }
    </div>

    <!-- Multi-day series option, owned by the hosting dialog -->
    <ng-content select="[series-section]" />

    @if (!showManualHoursBreakdown()) {
      <proffeo-report-summary
        [date]="seriesActive() ? null : summaryDate()"
        [periodLabel]="seriesActive() ? (series()?.periodLabel() ?? '') : ''"
        [modeLabelKey]="summaryModeLabelKey()"
        [projectLabel]="summaryProjectLabel()"
        [taskLabel]="summaryTaskLabel()"
        [locationLabel]="summaryLocationLabel()"
        [days]="summaryDays()"
        [durationPerDayMinutes]="summaryPerDayMinutes()"
        [totalMinutes]="summaryPerDayMinutes() * summaryDays()"
        [timeLabel]="summaryTimeLabel()"
        [createdByName]="summaryCreatedByName()"
        [createdAt]="summaryCreatedAt()"
        perDayLabelKey="time-reports-form-modal-duration"
      />
    }

    <!-- Comment -->
    <proffeo-ui-textarea
      [formField]="form().comment"
      errorMessage="errors.required"
      label="time-reports-comments-type-your-message"
    />

    <!-- File Attachments -->
    <proffeo-time-report-file-attachments></proffeo-time-report-file-attachments>
  </div>
</form>
